import React from "react";

interface AlertType {
  description: string;
}

function Alert({ description }: AlertType) {
  return (
    <div
      className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
      role="alert"
    >
      <span className="block sm:inline ml-1">{description}</span>
    </div>
  );
}

export default Alert;
